@use '../../style/functions';
@use '../../style/internal/shared_input-select-picker';

@use '@material/switch/styles';

$scale-factor: 0.8;

:host(limel-switch) {
    isolation: isolate;

    min-height: 1.75rem;

    display: flex;
    align-items: flex-start;
    gap: 0.5rem;

    --mdc-switch-selected-icon-color: transparent;
    --mdc-switch-unselected-icon-color: transparent;

    --mdc-switch-disabled-selected-icon-opacity: 1;
    --mdc-switch-disabled-unselected-icon-opacity: 1;

    --mdc-switch-selected-icon-size: 0.75rem;
    --mdc-switch-unselected-icon-size: 0.75rem;

    --mdc-switch-track-height: 1.25rem;
    --mdc-switch-track-shape: var(--mdc-switch-track-height);

    --mdc-switch-unselected-focus-handle-color: var(
        --lime-elevated-surface-background-color
    );
    --mdc-switch-selected-focus-handle-color: var(
        --lime-elevated-surface-background-color
    );
    --mdc-switch-unselected-pressed-handle-color: var(
        --lime-elevated-surface-background-color
    );
    --mdc-switch-selected-pressed-handle-color: var(
        --lime-elevated-surface-background-color
    );
    --mdc-switch-unselected-handle-color: var(
        --lime-elevated-surface-background-color
    );
    --mdc-switch-unselected-hover-handle-color: var(
        --lime-elevated-surface-background-color
    );
    --mdc-switch-selected-handle-color: var(
        --lime-elevated-surface-background-color
    );
    --mdc-switch-selected-hover-handle-color: var(
        --lime-elevated-surface-background-color
    );

    --mdc-switch-unselected-track-color: rgb(var(--contrast-700));
    --mdc-switch-unselected-focus-track-color: rgb(var(--contrast-800));
    --mdc-switch-unselected-pressed-track-color: rgb(var(--contrast-800));
    --mdc-switch-unselected-hover-track-color: rgb(var(--contrast-800));
    --mdc-switch-selected-focus-track-color: var(
        --lime-primary-color,
        var(--limel-theme-primary-color)
    );
    --mdc-switch-selected-pressed-track-color: var(
        --lime-primary-color,
        var(--limel-theme-primary-color)
    );
    --mdc-switch-selected-track-color: var(
        --lime-primary-color,
        var(--limel-theme-primary-color)
    );
    --mdc-switch-selected-hover-track-color: var(
        --lime-primary-color,
        var(--limel-theme-primary-color)
    );

    --mdc-switch-handle-elevation: var(--button-shadow-normal);
    --mdc-switch-disabled-track-opacity: 0.4;

    --mdc-switch-disabled-selected-handle-color: rgb(var(--contrast-1000));
    --mdc-switch-disabled-unselected-handle-color: rgb(var(--contrast-1000));
}

.mdc-switch {
    margin-top: 0.25rem;
    &:hover {
        --mdc-switch-handle-elevation: var(--button-shadow-hovered);
    }
}

label {
    padding-top: 0.25rem;
    font-size: var(--limel-theme-default-font-size);

    &:not(.disabled) {
        cursor: pointer;
    }
}

label {
    // As long as this component is depended on MDC,
    // we need to force it to be font-agnostic.
    // When MDC-dependency is removed, this block can also be removed.
    // However, on removal of MDC-dependency, we should also make sure to check
    // other font-related styles that might be set by MDC,
    // such as `letter-spacing` or `font-size`.
    font-family: inherit;
}

.mdc-switch {
    &.mdc-switch--selected,
    &.mdc-switch.mdc-switch--unselected {
        .mdc-switch__handle {
            &:after,
            &:before {
                transform: scale($scale-factor);
            }
        }
    }
    .mdc-switch__shadow {
        transform: scale($scale-factor);
    }
}

@import './partial-styles/_helper-text.scss';
